exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#alttext[data-v-6cbdf474]{font-size:.5rem!important}.lesson[data-v-6cbdf474]{padding:1rem;border:1px solid #fff;background-color:#f0f2f4}.lesson p[data-v-6cbdf474]{font-size:1.25em}.lec_img[data-v-6cbdf474]{border:1px solid #999;object-fit:fill}.btn_lec_eval.active[data-v-6cbdf474]{color:#212529!important;background-color:#ffc107!important;border-color:#ffc107!important}.btn_lec_eval.active[data-v-6cbdf474]:hover{color:#212529!important;background-color:#e0a800!important;border-color:#d39e00!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6cbdf474","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/lesson/LessonItem.vue
// module id = 76
// module chunks = 0